import {
    ADD_NOTIFICATION,
    AUTH_SUCCESSFUL,
    EMPTY_NOTIFICATION,
    GET_SUPPLIER,
    LOGOUT,
    UPDATE_BLOCKED_TIME,
    UPDATE_HERE_TOKEN
} from "../action";

const defaultState = () => {
    return {
        auth: null,
        supplier: null,
        alert: null,
        hereToken: null
    }
}

const general = (state = defaultState(), action) => {
    switch (action.type) {
        case GET_SUPPLIER:
            return {...state, supplier: action.payload}
        case AUTH_SUCCESSFUL:
            return {...state, auth: action.payload}
        case LOGOUT:
            return {...state, auth: false, supplier:null}
        case EMPTY_NOTIFICATION:
            return {...state, alert: null}
        case ADD_NOTIFICATION:
            return {...state, alert: action.payload}
        case UPDATE_BLOCKED_TIME:
            return {
                ...state, supplier: {
                    ...state.supplier,
                    blockedTimes: action.payload
                }
            }
        case UPDATE_HERE_TOKEN:
            const {access_token, token_type} = action.payload.data
            return {
                ...state,
                hereToken: `${token_type} ${access_token}`
            }

        default:
            return state
    }
}

export default general